<template>
  <div class="row justify-content-between mb-3">
    <div class="visible-items col">
      <strong>{{ count }}</strong> / <strong>{{ total }}</strong>
    </div>
    <div class="col text-right">
      <div>
        <a
          class="btn btn-default btn-sm"
          :class="{ 'btn-primary text-white': modelValue === 4 }"
          @click="$emit('update:modelValue', 4)"
          >4</a
        >
        <a
          class="btn btn-default btn-sm"
          :class="{ 'btn-primary text-white': modelValue === 12 }"
          @click="$emit('update:modelValue', 12)"
          >12</a
        >
        <a
          class="btn btn-default btn-sm"
          :class="{ 'btn-primary text-white': modelValue === 24 }"
          @click="$emit('update:modelValue', 24)"
          >24</a
        >
        <a
          class="btn btn-default btn-sm"
          :class="{ 'btn-primary text-white': modelValue === 1000 }"
          @click="$emit('update:modelValue', 1000)"
          >{{ $t('All') }}</a
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ItemCount',
  props: {
    modelValue: Number,
    count: Number,
    total: Number,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      itemsShown: this.itemsToShow,
    };
  },
});
</script>
